import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex: 1;
  box-sizing: border-box;
  margin: 0;
  color: rgb(0 0 0 / 88%);
  position: relative;
  background: #fff;
  border-radius: 8px;
  align-items: start;
  justify-content: center;
  padding: 16px;
  gap: 16px;
`;
export const IconWrapper = styled.div`
  width: 42px;
  display: flex;
`;
export const SummaryWrapper = styled.div`
  flex: 1;
`;
export const Title = styled.div`
  font-weight: 600;
  line-height: 22px;
`;
export const Content = styled.div`
  margin-top: 8px;
`;
export const Affect = styled.div`
  padding-bottom: 8px;
`;
export const RootCause = styled.div`
  margin-top: 16px;
`;
export const Rooter = styled.div`
  margin-top: 16px;
`;
export const HeightLight = styled.span`
  font-weight: 600;
`;
